






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { ActorType, ActorTypeNames } from '../../../src_server/biz/ActorType';
@Component({
  components: {},
  filters: {
    formatDt(d: Date) {
      return dayjs(d).format(DT_FORMAT_JA);
    },
  },
})
export default class TeachersRow extends Vue {
  @Prop()
  private row!: TeacherInfoInputDTO;

  @Prop()
  private index!: number;

  get age() {
    if (!this.row.teacher.birth_day) return '';
    return dayjs().diff(dayjs(this.row.teacher.birth_day), 'y');
  }

  get actorType() {
    if (!this.row.communicate.actor_type) return '';
    return ActorType.getInstanceByName(this.row.communicate.actor_type as ActorTypeNames).typeName;
  }

  async detail() {
    this.$emit('detail', this.row);
  }

  async document() {
    console.log('do');
    this.$emit('on-open-document', this.row);
  }

  async remail() {
    this.$emit('remail', this.row);
  }
  async reportLog() {
    this.$emit('report-log', this.row);
  }
}
